import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { scheduleCampaign } from '@/lib/venue/campaignApi'
import type { VenueCampaignDetailView } from '@/lib/venue/campaignTypes'

import { campaignDetailQueryKey } from './useCampaignDetail'

/**
 * 예약 확정(#714 §4-2, #732에서 처음 소비) — DRAFT→SCHEDULED. 발송은 아니지만 이력 목록에 SCHEDULED로
 * 노출돼야 하므로 요약·목록·상세 쿼리를 무효화한다(`useSendCampaign`과 같은 무효화 범위).
 */
export function useScheduleCampaign(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<VenueCampaignDetailView, ApiError, { campaignId: number; scheduledAt: string }>({
    mutationFn: ({ campaignId, scheduledAt }) => scheduleCampaign(venueId, campaignId, scheduledAt),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ['venue', venueId, 'campaign-summary'] })
      void queryClient.invalidateQueries({ queryKey: ['venue', venueId, 'campaigns'] })
      void queryClient.invalidateQueries({ queryKey: campaignDetailQueryKey(venueId, data.summary.id) })
    },
  })
}
